import { default as bucketlb06JyMwosMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/bucket.vue?macro=true";
import { default as cadastroformularionZ7A7bjhISMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/cadastroformulario.vue?macro=true";
import { default as componentesANHtan4zKGMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/componentes.vue?macro=true";
import { default as developer1uaIHpkWlsMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/developer.vue?macro=true";
import { default as indexcV2bCRjWTpMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/index.vue?macro=true";
import { default as mailconfiguracaoy3TEsilwWHMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/mailconfiguracao.vue?macro=true";
import { default as mailtemplates75UAfcXIveMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/mailtemplates.vue?macro=true";
import { default as permissoeswmfsAknBtlMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/permissoes.vue?macro=true";
import { default as redessociaisSiRpcJd5yxMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/redessociais.vue?macro=true";
import { default as seoDy4bDLXZgrMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/seo.vue?macro=true";
import { default as _91id_93nZmcNIF1zuMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/artigos/[id].vue?macro=true";
import { default as indexEIJOmIUB4fMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/artigos/index.vue?macro=true";
import { default as settingsVZTSUboU91Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/artigos/settings.vue?macro=true";
import { default as carrinhosOxS1fIJpU7Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/atacado/carrinhos.vue?macro=true";
import { default as indexsksYKiW6hHMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/atacado/index.vue?macro=true";
import { default as pedidosenU1PRkrdAMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/atacado/pedidos.vue?macro=true";
import { default as _91id_93h2WEvYoBw5Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/banners/[id].vue?macro=true";
import { default as indexruGAHBhFHsMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/banners/index.vue?macro=true";
import { default as novoWYqXaSEb3YMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/banners/novo.vue?macro=true";
import { default as settingsPcMeofCtw9Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/banners/settings.vue?macro=true";
import { default as _91componente_93bI20ano9NNMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/categorias/[componente].vue?macro=true";
import { default as _91componente_93xIOS9Z5k15Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/categorias/[id]/[componente].vue?macro=true";
import { default as _91id_93s9lm5R5atVMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/classificados/[id].vue?macro=true";
import { default as indexglgrIdkix6Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/classificados/index.vue?macro=true";
import { default as menucicsq1nFRhMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/classificados/menu.vue?macro=true";
import { default as settingsED78i7ZDQXMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/classificados/settings.vue?macro=true";
import { default as erroraLetdT2zzjMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/error.vue?macro=true";
import { default as _91id_93_46_91layout_93btcRxnNykmMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/galerias/[id].[layout].vue?macro=true";
import { default as _91id_93O8woM1XM1IMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/galerias/[id].vue?macro=true";
import { default as indexNduiTiP6HfMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/galerias/index.vue?macro=true";
import { default as _91id_93curjWthVSjMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/condominio/[id].vue?macro=true";
import { default as frmBuscaCondominios54cncQMKLFMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/condominio/frmBuscaCondominios.vue?macro=true";
import { default as condominiosIOEVD6XLrZMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/condominios.vue?macro=true";
import { default as _91id_93Tp1c6mgs7rMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/corretor/[id].vue?macro=true";
import { default as frmBuscaCorretoreshH5nvmKwCQMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/corretor/frmBuscaCorretores.vue?macro=true";
import { default as corretoresZymPh90eBmMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/corretores.vue?macro=true";
import { default as _91id_937dtCLLjEO0Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/imovel/[id].vue?macro=true";
import { default as descricaoD5dVXkLlGjMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/imovel/descricao.vue?macro=true";
import { default as enderecoAsaZIkvdPGMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/imovel/endereco.vue?macro=true";
import { default as frmBuscaFZXBuXQt5TMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/imovel/frmBusca.vue?macro=true";
import { default as imagensMrqvozbYvkMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/imovel/imagens.vue?macro=true";
import { default as indexU29wDtfTziMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/index.vue?macro=true";
import { default as listasSelectRnE5iRoXj5Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/listasSelect.js?macro=true";
import { default as menugJMIUdRJHKMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/menu.vue?macro=true";
import { default as _91id_93QECTdepSbUMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/proprietario/[id].vue?macro=true";
import { default as frmBuscaProprietariosczDgSzd1UBMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/proprietario/frmBuscaProprietarios.vue?macro=true";
import { default as proprietarioshOIcPw0cH0Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/proprietarios.vue?macro=true";
import { default as settingsOFgWSniSQXMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/settings.vue?macro=true";
import { default as indexbskdDolm2pMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/index.vue?macro=true";
import { default as indexlG7ppNcQQ0Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/login/index.vue?macro=true";
import { default as passwordnewKlqe9kjgYBMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/login/passwordnew.vue?macro=true";
import { default as passwordrecoverIeZuIR4eLhMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/login/passwordrecover.vue?macro=true";
import { default as passwordrecoverokEKGHOiqfJOMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/login/passwordrecoverok.vue?macro=true";
import { default as passwordrecovertoken0it3KZa9F0Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/login/passwordrecovertoken.vue?macro=true";
import { default as indexYdZsuZTHRNMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/menus/index.vue?macro=true";
import { default as indexZnY2LwIHmMMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/msmax/index.vue?macro=true";
import { default as _91id_93_46_91layout_93WfCns0W6DXMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooimagens/[id].[layout].vue?macro=true";
import { default as _91id_93Lo1HFVMJ00Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooimagens/[id].vue?macro=true";
import { default as indexyZJsYTTvEiMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooimagens/index.vue?macro=true";
import { default as index2XasjNMzyZMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/caracteristicas/index.vue?macro=true";
import { default as aba_45atributosR65GEZvq9VMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-atributos.vue?macro=true";
import { default as aba_45dimencoeFBaCs0VRR2Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-dimencoe.vue?macro=true";
import { default as aba_45ficha_45tecnica0X2A8RZUdTMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-ficha-tecnica.vue?macro=true";
import { default as aba_45inventariosb0P75CcjOMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-inventario.vue?macro=true";
import { default as aba_45produtos_45relacionadosa3lxIkSba1Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-produtos-relacionados.vue?macro=true";
import { default as aba_45remessaYHrTZ03lF6Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-remessa.vue?macro=true";
import { default as aba_45valoresDLLogke18rMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-valores.vue?macro=true";
import { default as aba_45variacoesyYDhUTbzIoMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-variacoes.vue?macro=true";
import { default as categoriaserIoz72frMMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/categorias.vue?macro=true";
import { default as index4bjHd8yyzPMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/index.vue?macro=true";
import { default as produto_45_91id_935rhVGU7GQSMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/produto-[id].vue?macro=true";
import { default as clientesofyJAWlc0jMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/clientes.vue?macro=true";
import { default as abasj0VWKqLkblMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/abas.vue?macro=true";
import { default as clienteswoMbAC0aFAMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/clientes.vue?macro=true";
import { default as empresa4Qh5OMkIikMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/empresa.vue?macro=true";
import { default as indexBXeeXn6JgYMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/index.vue?macro=true";
import { default as localizacaozMJzw9Mb90Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/localizacao.vue?macro=true";
import { default as produtos94qJYPTRNYMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/produtos.vue?macro=true";
import { default as indexwMqOSwzvHVMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/entregas/index.vue?macro=true";
import { default as _91id_93dPCRZQJkPiMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/fichatecnica/[id].vue?macro=true";
import { default as fichaOtDyFVDbGaMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/fichatecnica/ficha.vue?macro=true";
import { default as index_32copyuqCnIzJBG8Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/fichatecnica/index copy.vue?macro=true";
import { default as indexfkxN43RElUMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/fichatecnica/index.vue?macro=true";
import { default as indexmHk3M1rk1jMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/index.vue?macro=true";
import { default as menulateralucxtWBSF9uMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/menulateral.vue?macro=true";
import { default as settingsiidKkQXhK1Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/settings.vue?macro=true";
import { default as indexNv5if3amL9Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/vendas/index.vue?macro=true";
import { default as carrinhoswvTZqzLU7fMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/atacado/carrinhos.vue?macro=true";
import { default as catalogoGw3uTxFvu5Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/atacado/catalogo.vue?macro=true";
import { default as index9vScCBjkczMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/atacado/condicoes-parcelamento/index.vue?macro=true";
import { default as index6ILS3NzQVjMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/atacado/index.vue?macro=true";
import { default as pedidoskCFdlVxPFbMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/atacado/pedidos.vue?macro=true";
import { default as cliente_45_91id_931nT43GXXv2Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/cadastros/clientes/cliente-[id].vue?macro=true";
import { default as indexxiHmvcaiWGMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/cadastros/clientes/index.vue?macro=true";
import { default as _91id_93h9kD88aQqVMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/cadastros/fabricantes/[id].vue?macro=true";
import { default as indexS62OqCU5PjMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/cadastros/fabricantes/index.vue?macro=true";
import { default as indexPGVRk5TcJzMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/cadastros/index.vue?macro=true";
import { default as categoriasDx92HM3KJxMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/cadastros/produtos/categorias.vue?macro=true";
import { default as indexb7OpLTMcg9Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/cadastros/vendas/index.vue?macro=true";
import { default as aba_45avaliacoesHjE16DqZy6Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-avaliacoes.vue?macro=true";
import { default as aba_45comentarios753D629Nd8Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-comentarios.vue?macro=true";
import { default as aba_45dimencoe3SzkTaCXPeMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-dimencoe.vue?macro=true";
import { default as aba_45geral2BHjUFstWFMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-geral.vue?macro=true";
import { default as aba_45gerenciarestoque55kWSaLyLsMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-gerenciarestoque.vue?macro=true";
import { default as aba_45precos28ad4koM4EMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-precos.vue?macro=true";
import { default as aba_45variacoes2iZ1i1hHemMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-variacoes.vue?macro=true";
import { default as categoriasJWDeVdzEfIMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/categorias.vue?macro=true";
import { default as func_45variacoesTYeMMe4uRoMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/func-variacoes.js?macro=true";
import { default as imagens19RoxgahnoMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/imagens.vue?macro=true";
import { default as produto_45_91id_93Zni9w0s1ruMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/produto-[id].vue?macro=true";
import { default as produtosjjSmKivC3cMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/produtos.vue?macro=true";
import { default as variacoesrwDU5uI3XTMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/variacoes.vue?macro=true";
import { default as abas6znw0RwjHbMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/abas.vue?macro=true";
import { default as chatbotVdc0jWkMeNMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/chatbot.vue?macro=true";
import { default as clientesFAa6HKjvBAMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/clientes.vue?macro=true";
import { default as DEPRECATED_45empresaOovLPus9uOMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/DEPRECATED-empresa.vue?macro=true";
import { default as erpyfDBiG3neyMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/erp.vue?macro=true";
import { default as erpprodutosF6llPl5HT7Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/erpprodutos.vue?macro=true";
import { default as indexZlcMWqjoMvMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/index.vue?macro=true";
import { default as inputFormConfighCBh8uDET1Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/inputFormConfig.vue?macro=true";
import { default as localizacaowkUKShIefXMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/localizacao.vue?macro=true";
import { default as produtos5nRiM5VrTXMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/produtos.vue?macro=true";
import { default as sendformssdtm1gTJtHMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/sendforms.js?macro=true";
import { default as index4UXL9CjjsOMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/index.vue?macro=true";
import { default as menulateralsIn19Wwl1rMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/menulateral.vue?macro=true";
import { default as menuoolojaZozmWVOt3SMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/menuooloja.vue?macro=true";
import { default as settings9GuBOyGvzmMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/settings.vue?macro=true";
import { default as indexo8VqjevYfCMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/perfil/index.vue?macro=true";
import { default as gerapdfFEVSlrO9D8Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/testes/gerapdf.vue?macro=true";
import { default as grapsvJvPyRaoBQMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/testes/graps.vue?macro=true";
import { default as indexK0SLZVzWnsMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/testes/index.vue?macro=true";
import { default as mapasClEGhRnU8zMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/testes/mapas.vue?macro=true";
import { default as megasena6FxFVo4Va7Meta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/testes/megasena.vue?macro=true";
import { default as myPlugin1pRPYk3erWMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/testes/plugins/myPlugin.js?macro=true";
import { default as selecttbAuMsTd3pMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/testes/select.vue?macro=true";
import { default as tvLKhS8LyclMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/testes/t.vue?macro=true";
import { default as _91id_937eupM3tgHnMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/usuarios/[id].vue?macro=true";
import { default as indexAs8VwvyG2LMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/usuarios/index.vue?macro=true";
import { default as _91id_93tG7sK5a08TMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/videos/[id].vue?macro=true";
import { default as frmBuscas4J39Sj0ozMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/videos/frmBusca.vue?macro=true";
import { default as indexlUnunui40hMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/videos/index.vue?macro=true";
import { default as settingsv43Od2Pz0dMeta } from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/videos/settings.vue?macro=true";
export default [
  {
    name: bucketlb06JyMwosMeta?.name ?? "administracao-bucket",
    path: bucketlb06JyMwosMeta?.path ?? "/administracao/bucket",
    meta: bucketlb06JyMwosMeta || {},
    alias: bucketlb06JyMwosMeta?.alias || [],
    redirect: bucketlb06JyMwosMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/bucket.vue").then(m => m.default || m)
  },
  {
    name: cadastroformularionZ7A7bjhISMeta?.name ?? "administracao-cadastroformulario",
    path: cadastroformularionZ7A7bjhISMeta?.path ?? "/administracao/cadastroformulario",
    meta: cadastroformularionZ7A7bjhISMeta || {},
    alias: cadastroformularionZ7A7bjhISMeta?.alias || [],
    redirect: cadastroformularionZ7A7bjhISMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/cadastroformulario.vue").then(m => m.default || m)
  },
  {
    name: componentesANHtan4zKGMeta?.name ?? "administracao-componentes",
    path: componentesANHtan4zKGMeta?.path ?? "/administracao/componentes",
    meta: componentesANHtan4zKGMeta || {},
    alias: componentesANHtan4zKGMeta?.alias || [],
    redirect: componentesANHtan4zKGMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/componentes.vue").then(m => m.default || m)
  },
  {
    name: developer1uaIHpkWlsMeta?.name ?? "administracao-developer",
    path: developer1uaIHpkWlsMeta?.path ?? "/administracao/developer",
    meta: developer1uaIHpkWlsMeta || {},
    alias: developer1uaIHpkWlsMeta?.alias || [],
    redirect: developer1uaIHpkWlsMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/developer.vue").then(m => m.default || m)
  },
  {
    name: indexcV2bCRjWTpMeta?.name ?? "administracao",
    path: indexcV2bCRjWTpMeta?.path ?? "/administracao",
    meta: indexcV2bCRjWTpMeta || {},
    alias: indexcV2bCRjWTpMeta?.alias || [],
    redirect: indexcV2bCRjWTpMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/index.vue").then(m => m.default || m)
  },
  {
    name: mailconfiguracaoy3TEsilwWHMeta?.name ?? "administracao-mailconfiguracao",
    path: mailconfiguracaoy3TEsilwWHMeta?.path ?? "/administracao/mailconfiguracao",
    meta: mailconfiguracaoy3TEsilwWHMeta || {},
    alias: mailconfiguracaoy3TEsilwWHMeta?.alias || [],
    redirect: mailconfiguracaoy3TEsilwWHMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/mailconfiguracao.vue").then(m => m.default || m)
  },
  {
    name: mailtemplates75UAfcXIveMeta?.name ?? "administracao-mailtemplates",
    path: mailtemplates75UAfcXIveMeta?.path ?? "/administracao/mailtemplates",
    meta: mailtemplates75UAfcXIveMeta || {},
    alias: mailtemplates75UAfcXIveMeta?.alias || [],
    redirect: mailtemplates75UAfcXIveMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/mailtemplates.vue").then(m => m.default || m)
  },
  {
    name: permissoeswmfsAknBtlMeta?.name ?? "administracao-permissoes",
    path: permissoeswmfsAknBtlMeta?.path ?? "/administracao/permissoes",
    meta: permissoeswmfsAknBtlMeta || {},
    alias: permissoeswmfsAknBtlMeta?.alias || [],
    redirect: permissoeswmfsAknBtlMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/permissoes.vue").then(m => m.default || m)
  },
  {
    name: redessociaisSiRpcJd5yxMeta?.name ?? "administracao-redessociais",
    path: redessociaisSiRpcJd5yxMeta?.path ?? "/administracao/redessociais",
    meta: redessociaisSiRpcJd5yxMeta || {},
    alias: redessociaisSiRpcJd5yxMeta?.alias || [],
    redirect: redessociaisSiRpcJd5yxMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/redessociais.vue").then(m => m.default || m)
  },
  {
    name: seoDy4bDLXZgrMeta?.name ?? "administracao-seo",
    path: seoDy4bDLXZgrMeta?.path ?? "/administracao/seo",
    meta: seoDy4bDLXZgrMeta || {},
    alias: seoDy4bDLXZgrMeta?.alias || [],
    redirect: seoDy4bDLXZgrMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/administracao/seo.vue").then(m => m.default || m)
  },
  {
    name: _91id_93nZmcNIF1zuMeta?.name ?? "artigos-id",
    path: _91id_93nZmcNIF1zuMeta?.path ?? "/artigos/:id()",
    meta: _91id_93nZmcNIF1zuMeta || {},
    alias: _91id_93nZmcNIF1zuMeta?.alias || [],
    redirect: _91id_93nZmcNIF1zuMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/artigos/[id].vue").then(m => m.default || m)
  },
  {
    name: indexEIJOmIUB4fMeta?.name ?? "artigos",
    path: indexEIJOmIUB4fMeta?.path ?? "/artigos",
    meta: indexEIJOmIUB4fMeta || {},
    alias: indexEIJOmIUB4fMeta?.alias || [],
    redirect: indexEIJOmIUB4fMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/artigos/index.vue").then(m => m.default || m)
  },
  {
    name: settingsVZTSUboU91Meta?.name ?? "artigos-settings",
    path: settingsVZTSUboU91Meta?.path ?? "/artigos/settings",
    meta: settingsVZTSUboU91Meta || {},
    alias: settingsVZTSUboU91Meta?.alias || [],
    redirect: settingsVZTSUboU91Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/artigos/settings.vue").then(m => m.default || m)
  },
  {
    name: carrinhosOxS1fIJpU7Meta?.name ?? "atacado-carrinhos",
    path: carrinhosOxS1fIJpU7Meta?.path ?? "/atacado/carrinhos",
    meta: carrinhosOxS1fIJpU7Meta || {},
    alias: carrinhosOxS1fIJpU7Meta?.alias || [],
    redirect: carrinhosOxS1fIJpU7Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/atacado/carrinhos.vue").then(m => m.default || m)
  },
  {
    name: indexsksYKiW6hHMeta?.name ?? "atacado",
    path: indexsksYKiW6hHMeta?.path ?? "/atacado",
    meta: indexsksYKiW6hHMeta || {},
    alias: indexsksYKiW6hHMeta?.alias || [],
    redirect: indexsksYKiW6hHMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/atacado/index.vue").then(m => m.default || m)
  },
  {
    name: pedidosenU1PRkrdAMeta?.name ?? "atacado-pedidos",
    path: pedidosenU1PRkrdAMeta?.path ?? "/atacado/pedidos",
    meta: pedidosenU1PRkrdAMeta || {},
    alias: pedidosenU1PRkrdAMeta?.alias || [],
    redirect: pedidosenU1PRkrdAMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/atacado/pedidos.vue").then(m => m.default || m)
  },
  {
    name: _91id_93h2WEvYoBw5Meta?.name ?? "banners-id",
    path: _91id_93h2WEvYoBw5Meta?.path ?? "/banners/:id()",
    meta: _91id_93h2WEvYoBw5Meta || {},
    alias: _91id_93h2WEvYoBw5Meta?.alias || [],
    redirect: _91id_93h2WEvYoBw5Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/banners/[id].vue").then(m => m.default || m)
  },
  {
    name: indexruGAHBhFHsMeta?.name ?? "banners",
    path: indexruGAHBhFHsMeta?.path ?? "/banners",
    meta: indexruGAHBhFHsMeta || {},
    alias: indexruGAHBhFHsMeta?.alias || [],
    redirect: indexruGAHBhFHsMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/banners/index.vue").then(m => m.default || m)
  },
  {
    name: novoWYqXaSEb3YMeta?.name ?? "banners-novo",
    path: novoWYqXaSEb3YMeta?.path ?? "/banners/novo",
    meta: novoWYqXaSEb3YMeta || {},
    alias: novoWYqXaSEb3YMeta?.alias || [],
    redirect: novoWYqXaSEb3YMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/banners/novo.vue").then(m => m.default || m)
  },
  {
    name: settingsPcMeofCtw9Meta?.name ?? "banners-settings",
    path: settingsPcMeofCtw9Meta?.path ?? "/banners/settings",
    meta: settingsPcMeofCtw9Meta || {},
    alias: settingsPcMeofCtw9Meta?.alias || [],
    redirect: settingsPcMeofCtw9Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/banners/settings.vue").then(m => m.default || m)
  },
  {
    name: _91componente_93bI20ano9NNMeta?.name ?? "categorias-componente",
    path: _91componente_93bI20ano9NNMeta?.path ?? "/categorias/:componente()",
    meta: _91componente_93bI20ano9NNMeta || {},
    alias: _91componente_93bI20ano9NNMeta?.alias || [],
    redirect: _91componente_93bI20ano9NNMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/categorias/[componente].vue").then(m => m.default || m)
  },
  {
    name: _91componente_93xIOS9Z5k15Meta?.name ?? "categorias-id-componente",
    path: _91componente_93xIOS9Z5k15Meta?.path ?? "/categorias/:id()/:componente()",
    meta: _91componente_93xIOS9Z5k15Meta || {},
    alias: _91componente_93xIOS9Z5k15Meta?.alias || [],
    redirect: _91componente_93xIOS9Z5k15Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/categorias/[id]/[componente].vue").then(m => m.default || m)
  },
  {
    name: _91id_93s9lm5R5atVMeta?.name ?? "classificados-id",
    path: _91id_93s9lm5R5atVMeta?.path ?? "/classificados/:id()",
    meta: _91id_93s9lm5R5atVMeta || {},
    alias: _91id_93s9lm5R5atVMeta?.alias || [],
    redirect: _91id_93s9lm5R5atVMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/classificados/[id].vue").then(m => m.default || m)
  },
  {
    name: indexglgrIdkix6Meta?.name ?? "classificados",
    path: indexglgrIdkix6Meta?.path ?? "/classificados",
    meta: indexglgrIdkix6Meta || {},
    alias: indexglgrIdkix6Meta?.alias || [],
    redirect: indexglgrIdkix6Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/classificados/index.vue").then(m => m.default || m)
  },
  {
    name: menucicsq1nFRhMeta?.name ?? "classificados-menu",
    path: menucicsq1nFRhMeta?.path ?? "/classificados/menu",
    meta: menucicsq1nFRhMeta || {},
    alias: menucicsq1nFRhMeta?.alias || [],
    redirect: menucicsq1nFRhMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/classificados/menu.vue").then(m => m.default || m)
  },
  {
    name: settingsED78i7ZDQXMeta?.name ?? "classificados-settings",
    path: settingsED78i7ZDQXMeta?.path ?? "/classificados/settings",
    meta: settingsED78i7ZDQXMeta || {},
    alias: settingsED78i7ZDQXMeta?.alias || [],
    redirect: settingsED78i7ZDQXMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/classificados/settings.vue").then(m => m.default || m)
  },
  {
    name: erroraLetdT2zzjMeta?.name ?? "error",
    path: erroraLetdT2zzjMeta?.path ?? "/error",
    meta: erroraLetdT2zzjMeta || {},
    alias: erroraLetdT2zzjMeta?.alias || [],
    redirect: erroraLetdT2zzjMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/error.vue").then(m => m.default || m)
  },
  {
    name: _91id_93_46_91layout_93btcRxnNykmMeta?.name ?? "galerias-id.layout",
    path: _91id_93_46_91layout_93btcRxnNykmMeta?.path ?? "/galerias/:id().:layout()",
    meta: _91id_93_46_91layout_93btcRxnNykmMeta || {},
    alias: _91id_93_46_91layout_93btcRxnNykmMeta?.alias || [],
    redirect: _91id_93_46_91layout_93btcRxnNykmMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/galerias/[id].[layout].vue").then(m => m.default || m)
  },
  {
    name: _91id_93O8woM1XM1IMeta?.name ?? "galerias-id",
    path: _91id_93O8woM1XM1IMeta?.path ?? "/galerias/:id()",
    meta: _91id_93O8woM1XM1IMeta || {},
    alias: _91id_93O8woM1XM1IMeta?.alias || [],
    redirect: _91id_93O8woM1XM1IMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/galerias/[id].vue").then(m => m.default || m)
  },
  {
    name: indexNduiTiP6HfMeta?.name ?? "galerias",
    path: indexNduiTiP6HfMeta?.path ?? "/galerias",
    meta: indexNduiTiP6HfMeta || {},
    alias: indexNduiTiP6HfMeta?.alias || [],
    redirect: indexNduiTiP6HfMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/galerias/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93curjWthVSjMeta?.name ?? "imoveis-condominio-id",
    path: _91id_93curjWthVSjMeta?.path ?? "/imoveis/condominio/:id()",
    meta: _91id_93curjWthVSjMeta || {},
    alias: _91id_93curjWthVSjMeta?.alias || [],
    redirect: _91id_93curjWthVSjMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/condominio/[id].vue").then(m => m.default || m)
  },
  {
    name: frmBuscaCondominios54cncQMKLFMeta?.name ?? "imoveis-condominio-frmBuscaCondominios",
    path: frmBuscaCondominios54cncQMKLFMeta?.path ?? "/imoveis/condominio/frmBuscaCondominios",
    meta: frmBuscaCondominios54cncQMKLFMeta || {},
    alias: frmBuscaCondominios54cncQMKLFMeta?.alias || [],
    redirect: frmBuscaCondominios54cncQMKLFMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/condominio/frmBuscaCondominios.vue").then(m => m.default || m)
  },
  {
    name: condominiosIOEVD6XLrZMeta?.name ?? "imoveis-condominios",
    path: condominiosIOEVD6XLrZMeta?.path ?? "/imoveis/condominios",
    meta: condominiosIOEVD6XLrZMeta || {},
    alias: condominiosIOEVD6XLrZMeta?.alias || [],
    redirect: condominiosIOEVD6XLrZMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/condominios.vue").then(m => m.default || m)
  },
  {
    name: _91id_93Tp1c6mgs7rMeta?.name ?? "imoveis-corretor-id",
    path: _91id_93Tp1c6mgs7rMeta?.path ?? "/imoveis/corretor/:id()",
    meta: _91id_93Tp1c6mgs7rMeta || {},
    alias: _91id_93Tp1c6mgs7rMeta?.alias || [],
    redirect: _91id_93Tp1c6mgs7rMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/corretor/[id].vue").then(m => m.default || m)
  },
  {
    name: frmBuscaCorretoreshH5nvmKwCQMeta?.name ?? "imoveis-corretor-frmBuscaCorretores",
    path: frmBuscaCorretoreshH5nvmKwCQMeta?.path ?? "/imoveis/corretor/frmBuscaCorretores",
    meta: frmBuscaCorretoreshH5nvmKwCQMeta || {},
    alias: frmBuscaCorretoreshH5nvmKwCQMeta?.alias || [],
    redirect: frmBuscaCorretoreshH5nvmKwCQMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/corretor/frmBuscaCorretores.vue").then(m => m.default || m)
  },
  {
    name: corretoresZymPh90eBmMeta?.name ?? "imoveis-corretores",
    path: corretoresZymPh90eBmMeta?.path ?? "/imoveis/corretores",
    meta: corretoresZymPh90eBmMeta || {},
    alias: corretoresZymPh90eBmMeta?.alias || [],
    redirect: corretoresZymPh90eBmMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/corretores.vue").then(m => m.default || m)
  },
  {
    name: _91id_937dtCLLjEO0Meta?.name ?? "imoveis-imovel-id",
    path: _91id_937dtCLLjEO0Meta?.path ?? "/imoveis/imovel/:id()",
    meta: _91id_937dtCLLjEO0Meta || {},
    alias: _91id_937dtCLLjEO0Meta?.alias || [],
    redirect: _91id_937dtCLLjEO0Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/imovel/[id].vue").then(m => m.default || m)
  },
  {
    name: descricaoD5dVXkLlGjMeta?.name ?? "imoveis-imovel-descricao",
    path: descricaoD5dVXkLlGjMeta?.path ?? "/imoveis/imovel/descricao",
    meta: descricaoD5dVXkLlGjMeta || {},
    alias: descricaoD5dVXkLlGjMeta?.alias || [],
    redirect: descricaoD5dVXkLlGjMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/imovel/descricao.vue").then(m => m.default || m)
  },
  {
    name: enderecoAsaZIkvdPGMeta?.name ?? "imoveis-imovel-endereco",
    path: enderecoAsaZIkvdPGMeta?.path ?? "/imoveis/imovel/endereco",
    meta: enderecoAsaZIkvdPGMeta || {},
    alias: enderecoAsaZIkvdPGMeta?.alias || [],
    redirect: enderecoAsaZIkvdPGMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/imovel/endereco.vue").then(m => m.default || m)
  },
  {
    name: frmBuscaFZXBuXQt5TMeta?.name ?? "imoveis-imovel-frmBusca",
    path: frmBuscaFZXBuXQt5TMeta?.path ?? "/imoveis/imovel/frmBusca",
    meta: frmBuscaFZXBuXQt5TMeta || {},
    alias: frmBuscaFZXBuXQt5TMeta?.alias || [],
    redirect: frmBuscaFZXBuXQt5TMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/imovel/frmBusca.vue").then(m => m.default || m)
  },
  {
    name: imagensMrqvozbYvkMeta?.name ?? "imoveis-imovel-imagens",
    path: imagensMrqvozbYvkMeta?.path ?? "/imoveis/imovel/imagens",
    meta: imagensMrqvozbYvkMeta || {},
    alias: imagensMrqvozbYvkMeta?.alias || [],
    redirect: imagensMrqvozbYvkMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/imovel/imagens.vue").then(m => m.default || m)
  },
  {
    name: indexU29wDtfTziMeta?.name ?? "imoveis",
    path: indexU29wDtfTziMeta?.path ?? "/imoveis",
    meta: indexU29wDtfTziMeta || {},
    alias: indexU29wDtfTziMeta?.alias || [],
    redirect: indexU29wDtfTziMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/index.vue").then(m => m.default || m)
  },
  {
    name: listasSelectRnE5iRoXj5Meta?.name ?? "imoveis-listasSelect",
    path: listasSelectRnE5iRoXj5Meta?.path ?? "/imoveis/listasSelect",
    meta: listasSelectRnE5iRoXj5Meta || {},
    alias: listasSelectRnE5iRoXj5Meta?.alias || [],
    redirect: listasSelectRnE5iRoXj5Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/listasSelect.js").then(m => m.default || m)
  },
  {
    name: menugJMIUdRJHKMeta?.name ?? "imoveis-menu",
    path: menugJMIUdRJHKMeta?.path ?? "/imoveis/menu",
    meta: menugJMIUdRJHKMeta || {},
    alias: menugJMIUdRJHKMeta?.alias || [],
    redirect: menugJMIUdRJHKMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/menu.vue").then(m => m.default || m)
  },
  {
    name: _91id_93QECTdepSbUMeta?.name ?? "imoveis-proprietario-id",
    path: _91id_93QECTdepSbUMeta?.path ?? "/imoveis/proprietario/:id()",
    meta: _91id_93QECTdepSbUMeta || {},
    alias: _91id_93QECTdepSbUMeta?.alias || [],
    redirect: _91id_93QECTdepSbUMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/proprietario/[id].vue").then(m => m.default || m)
  },
  {
    name: frmBuscaProprietariosczDgSzd1UBMeta?.name ?? "imoveis-proprietario-frmBuscaProprietarios",
    path: frmBuscaProprietariosczDgSzd1UBMeta?.path ?? "/imoveis/proprietario/frmBuscaProprietarios",
    meta: frmBuscaProprietariosczDgSzd1UBMeta || {},
    alias: frmBuscaProprietariosczDgSzd1UBMeta?.alias || [],
    redirect: frmBuscaProprietariosczDgSzd1UBMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/proprietario/frmBuscaProprietarios.vue").then(m => m.default || m)
  },
  {
    name: proprietarioshOIcPw0cH0Meta?.name ?? "imoveis-proprietarios",
    path: proprietarioshOIcPw0cH0Meta?.path ?? "/imoveis/proprietarios",
    meta: proprietarioshOIcPw0cH0Meta || {},
    alias: proprietarioshOIcPw0cH0Meta?.alias || [],
    redirect: proprietarioshOIcPw0cH0Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/proprietarios.vue").then(m => m.default || m)
  },
  {
    name: settingsOFgWSniSQXMeta?.name ?? "imoveis-settings",
    path: settingsOFgWSniSQXMeta?.path ?? "/imoveis/settings",
    meta: settingsOFgWSniSQXMeta || {},
    alias: settingsOFgWSniSQXMeta?.alias || [],
    redirect: settingsOFgWSniSQXMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/imoveis/settings.vue").then(m => m.default || m)
  },
  {
    name: indexbskdDolm2pMeta?.name ?? "index",
    path: indexbskdDolm2pMeta?.path ?? "/",
    meta: indexbskdDolm2pMeta || {},
    alias: indexbskdDolm2pMeta?.alias || [],
    redirect: indexbskdDolm2pMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexlG7ppNcQQ0Meta?.name ?? "login",
    path: indexlG7ppNcQQ0Meta?.path ?? "/login",
    meta: indexlG7ppNcQQ0Meta || {},
    alias: indexlG7ppNcQQ0Meta?.alias || [],
    redirect: indexlG7ppNcQQ0Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: passwordnewKlqe9kjgYBMeta?.name ?? "login-passwordnew",
    path: passwordnewKlqe9kjgYBMeta?.path ?? "/login/passwordnew",
    meta: passwordnewKlqe9kjgYBMeta || {},
    alias: passwordnewKlqe9kjgYBMeta?.alias || [],
    redirect: passwordnewKlqe9kjgYBMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/login/passwordnew.vue").then(m => m.default || m)
  },
  {
    name: passwordrecoverIeZuIR4eLhMeta?.name ?? "login-passwordrecover",
    path: passwordrecoverIeZuIR4eLhMeta?.path ?? "/login/passwordrecover",
    meta: passwordrecoverIeZuIR4eLhMeta || {},
    alias: passwordrecoverIeZuIR4eLhMeta?.alias || [],
    redirect: passwordrecoverIeZuIR4eLhMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/login/passwordrecover.vue").then(m => m.default || m)
  },
  {
    name: passwordrecoverokEKGHOiqfJOMeta?.name ?? "login-passwordrecoverok",
    path: passwordrecoverokEKGHOiqfJOMeta?.path ?? "/login/passwordrecoverok",
    meta: passwordrecoverokEKGHOiqfJOMeta || {},
    alias: passwordrecoverokEKGHOiqfJOMeta?.alias || [],
    redirect: passwordrecoverokEKGHOiqfJOMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/login/passwordrecoverok.vue").then(m => m.default || m)
  },
  {
    name: passwordrecovertoken0it3KZa9F0Meta?.name ?? "login-passwordrecovertoken",
    path: passwordrecovertoken0it3KZa9F0Meta?.path ?? "/login/passwordrecovertoken",
    meta: passwordrecovertoken0it3KZa9F0Meta || {},
    alias: passwordrecovertoken0it3KZa9F0Meta?.alias || [],
    redirect: passwordrecovertoken0it3KZa9F0Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/login/passwordrecovertoken.vue").then(m => m.default || m)
  },
  {
    name: indexYdZsuZTHRNMeta?.name ?? "menus",
    path: indexYdZsuZTHRNMeta?.path ?? "/menus",
    meta: indexYdZsuZTHRNMeta || {},
    alias: indexYdZsuZTHRNMeta?.alias || [],
    redirect: indexYdZsuZTHRNMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/menus/index.vue").then(m => m.default || m)
  },
  {
    name: indexZnY2LwIHmMMeta?.name ?? "msmax",
    path: indexZnY2LwIHmMMeta?.path ?? "/msmax",
    meta: indexZnY2LwIHmMMeta || {},
    alias: indexZnY2LwIHmMMeta?.alias || [],
    redirect: indexZnY2LwIHmMMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/msmax/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93_46_91layout_93WfCns0W6DXMeta?.name ?? "ooimagens-id.layout",
    path: _91id_93_46_91layout_93WfCns0W6DXMeta?.path ?? "/ooimagens/:id().:layout()",
    meta: _91id_93_46_91layout_93WfCns0W6DXMeta || {},
    alias: _91id_93_46_91layout_93WfCns0W6DXMeta?.alias || [],
    redirect: _91id_93_46_91layout_93WfCns0W6DXMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooimagens/[id].[layout].vue").then(m => m.default || m)
  },
  {
    name: _91id_93Lo1HFVMJ00Meta?.name ?? "ooimagens-id",
    path: _91id_93Lo1HFVMJ00Meta?.path ?? "/ooimagens/:id()",
    meta: _91id_93Lo1HFVMJ00Meta || {},
    alias: _91id_93Lo1HFVMJ00Meta?.alias || [],
    redirect: _91id_93Lo1HFVMJ00Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooimagens/[id].vue").then(m => m.default || m)
  },
  {
    name: indexyZJsYTTvEiMeta?.name ?? "ooimagens",
    path: indexyZJsYTTvEiMeta?.path ?? "/ooimagens",
    meta: indexyZJsYTTvEiMeta || {},
    alias: indexyZJsYTTvEiMeta?.alias || [],
    redirect: indexyZJsYTTvEiMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooimagens/index.vue").then(m => m.default || m)
  },
  {
    name: index2XasjNMzyZMeta?.name ?? "ooloja.old-caracteristicas",
    path: index2XasjNMzyZMeta?.path ?? "/ooloja.old/caracteristicas",
    meta: index2XasjNMzyZMeta || {},
    alias: index2XasjNMzyZMeta?.alias || [],
    redirect: index2XasjNMzyZMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/caracteristicas/index.vue").then(m => m.default || m)
  },
  {
    name: aba_45atributosR65GEZvq9VMeta?.name ?? "ooloja.old-catalogo-aba-atributos",
    path: aba_45atributosR65GEZvq9VMeta?.path ?? "/ooloja.old/catalogo/aba-atributos",
    meta: aba_45atributosR65GEZvq9VMeta || {},
    alias: aba_45atributosR65GEZvq9VMeta?.alias || [],
    redirect: aba_45atributosR65GEZvq9VMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-atributos.vue").then(m => m.default || m)
  },
  {
    name: aba_45dimencoeFBaCs0VRR2Meta?.name ?? "ooloja.old-catalogo-aba-dimencoe",
    path: aba_45dimencoeFBaCs0VRR2Meta?.path ?? "/ooloja.old/catalogo/aba-dimencoe",
    meta: aba_45dimencoeFBaCs0VRR2Meta || {},
    alias: aba_45dimencoeFBaCs0VRR2Meta?.alias || [],
    redirect: aba_45dimencoeFBaCs0VRR2Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-dimencoe.vue").then(m => m.default || m)
  },
  {
    name: aba_45ficha_45tecnica0X2A8RZUdTMeta?.name ?? "ooloja.old-catalogo-aba-ficha-tecnica",
    path: aba_45ficha_45tecnica0X2A8RZUdTMeta?.path ?? "/ooloja.old/catalogo/aba-ficha-tecnica",
    meta: aba_45ficha_45tecnica0X2A8RZUdTMeta || {},
    alias: aba_45ficha_45tecnica0X2A8RZUdTMeta?.alias || [],
    redirect: aba_45ficha_45tecnica0X2A8RZUdTMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-ficha-tecnica.vue").then(m => m.default || m)
  },
  {
    name: aba_45inventariosb0P75CcjOMeta?.name ?? "ooloja.old-catalogo-aba-inventario",
    path: aba_45inventariosb0P75CcjOMeta?.path ?? "/ooloja.old/catalogo/aba-inventario",
    meta: aba_45inventariosb0P75CcjOMeta || {},
    alias: aba_45inventariosb0P75CcjOMeta?.alias || [],
    redirect: aba_45inventariosb0P75CcjOMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-inventario.vue").then(m => m.default || m)
  },
  {
    name: aba_45produtos_45relacionadosa3lxIkSba1Meta?.name ?? "ooloja.old-catalogo-aba-produtos-relacionados",
    path: aba_45produtos_45relacionadosa3lxIkSba1Meta?.path ?? "/ooloja.old/catalogo/aba-produtos-relacionados",
    meta: aba_45produtos_45relacionadosa3lxIkSba1Meta || {},
    alias: aba_45produtos_45relacionadosa3lxIkSba1Meta?.alias || [],
    redirect: aba_45produtos_45relacionadosa3lxIkSba1Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-produtos-relacionados.vue").then(m => m.default || m)
  },
  {
    name: aba_45remessaYHrTZ03lF6Meta?.name ?? "ooloja.old-catalogo-aba-remessa",
    path: aba_45remessaYHrTZ03lF6Meta?.path ?? "/ooloja.old/catalogo/aba-remessa",
    meta: aba_45remessaYHrTZ03lF6Meta || {},
    alias: aba_45remessaYHrTZ03lF6Meta?.alias || [],
    redirect: aba_45remessaYHrTZ03lF6Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-remessa.vue").then(m => m.default || m)
  },
  {
    name: aba_45valoresDLLogke18rMeta?.name ?? "ooloja.old-catalogo-aba-valores",
    path: aba_45valoresDLLogke18rMeta?.path ?? "/ooloja.old/catalogo/aba-valores",
    meta: aba_45valoresDLLogke18rMeta || {},
    alias: aba_45valoresDLLogke18rMeta?.alias || [],
    redirect: aba_45valoresDLLogke18rMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-valores.vue").then(m => m.default || m)
  },
  {
    name: aba_45variacoesyYDhUTbzIoMeta?.name ?? "ooloja.old-catalogo-aba-variacoes",
    path: aba_45variacoesyYDhUTbzIoMeta?.path ?? "/ooloja.old/catalogo/aba-variacoes",
    meta: aba_45variacoesyYDhUTbzIoMeta || {},
    alias: aba_45variacoesyYDhUTbzIoMeta?.alias || [],
    redirect: aba_45variacoesyYDhUTbzIoMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/aba-variacoes.vue").then(m => m.default || m)
  },
  {
    name: categoriaserIoz72frMMeta?.name ?? "ooloja.old-catalogo-categorias",
    path: categoriaserIoz72frMMeta?.path ?? "/ooloja.old/catalogo/categorias",
    meta: categoriaserIoz72frMMeta || {},
    alias: categoriaserIoz72frMMeta?.alias || [],
    redirect: categoriaserIoz72frMMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/categorias.vue").then(m => m.default || m)
  },
  {
    name: index4bjHd8yyzPMeta?.name ?? "ooloja.old-catalogo",
    path: index4bjHd8yyzPMeta?.path ?? "/ooloja.old/catalogo",
    meta: index4bjHd8yyzPMeta || {},
    alias: index4bjHd8yyzPMeta?.alias || [],
    redirect: index4bjHd8yyzPMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/index.vue").then(m => m.default || m)
  },
  {
    name: produto_45_91id_935rhVGU7GQSMeta?.name ?? "ooloja.old-catalogo-produto-id",
    path: produto_45_91id_935rhVGU7GQSMeta?.path ?? "/ooloja.old/catalogo/produto-:id()",
    meta: produto_45_91id_935rhVGU7GQSMeta || {},
    alias: produto_45_91id_935rhVGU7GQSMeta?.alias || [],
    redirect: produto_45_91id_935rhVGU7GQSMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/catalogo/produto-[id].vue").then(m => m.default || m)
  },
  {
    name: clientesofyJAWlc0jMeta?.name ?? "ooloja.old-clientes",
    path: clientesofyJAWlc0jMeta?.path ?? "/ooloja.old/clientes",
    meta: clientesofyJAWlc0jMeta || {},
    alias: clientesofyJAWlc0jMeta?.alias || [],
    redirect: clientesofyJAWlc0jMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/clientes.vue").then(m => m.default || m)
  },
  {
    name: abasj0VWKqLkblMeta?.name ?? "ooloja.old-configuracoes-abas",
    path: abasj0VWKqLkblMeta?.path ?? "/ooloja.old/configuracoes/abas",
    meta: abasj0VWKqLkblMeta || {},
    alias: abasj0VWKqLkblMeta?.alias || [],
    redirect: abasj0VWKqLkblMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/abas.vue").then(m => m.default || m)
  },
  {
    name: clienteswoMbAC0aFAMeta?.name ?? "ooloja.old-configuracoes-clientes",
    path: clienteswoMbAC0aFAMeta?.path ?? "/ooloja.old/configuracoes/clientes",
    meta: clienteswoMbAC0aFAMeta || {},
    alias: clienteswoMbAC0aFAMeta?.alias || [],
    redirect: clienteswoMbAC0aFAMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/clientes.vue").then(m => m.default || m)
  },
  {
    name: empresa4Qh5OMkIikMeta?.name ?? "ooloja.old-configuracoes-empresa",
    path: empresa4Qh5OMkIikMeta?.path ?? "/ooloja.old/configuracoes/empresa",
    meta: empresa4Qh5OMkIikMeta || {},
    alias: empresa4Qh5OMkIikMeta?.alias || [],
    redirect: empresa4Qh5OMkIikMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/empresa.vue").then(m => m.default || m)
  },
  {
    name: indexBXeeXn6JgYMeta?.name ?? "ooloja.old-configuracoes",
    path: indexBXeeXn6JgYMeta?.path ?? "/ooloja.old/configuracoes",
    meta: indexBXeeXn6JgYMeta || {},
    alias: indexBXeeXn6JgYMeta?.alias || [],
    redirect: indexBXeeXn6JgYMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/index.vue").then(m => m.default || m)
  },
  {
    name: localizacaozMJzw9Mb90Meta?.name ?? "ooloja.old-configuracoes-localizacao",
    path: localizacaozMJzw9Mb90Meta?.path ?? "/ooloja.old/configuracoes/localizacao",
    meta: localizacaozMJzw9Mb90Meta || {},
    alias: localizacaozMJzw9Mb90Meta?.alias || [],
    redirect: localizacaozMJzw9Mb90Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/localizacao.vue").then(m => m.default || m)
  },
  {
    name: produtos94qJYPTRNYMeta?.name ?? "ooloja.old-configuracoes-produtos",
    path: produtos94qJYPTRNYMeta?.path ?? "/ooloja.old/configuracoes/produtos",
    meta: produtos94qJYPTRNYMeta || {},
    alias: produtos94qJYPTRNYMeta?.alias || [],
    redirect: produtos94qJYPTRNYMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/configuracoes/produtos.vue").then(m => m.default || m)
  },
  {
    name: indexwMqOSwzvHVMeta?.name ?? "ooloja.old-entregas",
    path: indexwMqOSwzvHVMeta?.path ?? "/ooloja.old/entregas",
    meta: indexwMqOSwzvHVMeta || {},
    alias: indexwMqOSwzvHVMeta?.alias || [],
    redirect: indexwMqOSwzvHVMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/entregas/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93dPCRZQJkPiMeta?.name ?? "ooloja.old-fichatecnica-id",
    path: _91id_93dPCRZQJkPiMeta?.path ?? "/ooloja.old/fichatecnica/:id()",
    meta: _91id_93dPCRZQJkPiMeta || {},
    alias: _91id_93dPCRZQJkPiMeta?.alias || [],
    redirect: _91id_93dPCRZQJkPiMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/fichatecnica/[id].vue").then(m => m.default || m)
  },
  {
    name: fichaOtDyFVDbGaMeta?.name ?? "ooloja.old-fichatecnica-ficha",
    path: fichaOtDyFVDbGaMeta?.path ?? "/ooloja.old/fichatecnica/ficha",
    meta: fichaOtDyFVDbGaMeta || {},
    alias: fichaOtDyFVDbGaMeta?.alias || [],
    redirect: fichaOtDyFVDbGaMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/fichatecnica/ficha.vue").then(m => m.default || m)
  },
  {
    name: index_32copyuqCnIzJBG8Meta?.name ?? "ooloja.old-fichatecnica-index copy",
    path: index_32copyuqCnIzJBG8Meta?.path ?? "/ooloja.old/fichatecnica/index%20copy",
    meta: index_32copyuqCnIzJBG8Meta || {},
    alias: index_32copyuqCnIzJBG8Meta?.alias || [],
    redirect: index_32copyuqCnIzJBG8Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/fichatecnica/index copy.vue").then(m => m.default || m)
  },
  {
    name: indexfkxN43RElUMeta?.name ?? "ooloja.old-fichatecnica",
    path: indexfkxN43RElUMeta?.path ?? "/ooloja.old/fichatecnica",
    meta: indexfkxN43RElUMeta || {},
    alias: indexfkxN43RElUMeta?.alias || [],
    redirect: indexfkxN43RElUMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/fichatecnica/index.vue").then(m => m.default || m)
  },
  {
    name: indexmHk3M1rk1jMeta?.name ?? "ooloja.old",
    path: indexmHk3M1rk1jMeta?.path ?? "/ooloja.old",
    meta: indexmHk3M1rk1jMeta || {},
    alias: indexmHk3M1rk1jMeta?.alias || [],
    redirect: indexmHk3M1rk1jMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/index.vue").then(m => m.default || m)
  },
  {
    name: menulateralucxtWBSF9uMeta?.name ?? "ooloja.old-menulateral",
    path: menulateralucxtWBSF9uMeta?.path ?? "/ooloja.old/menulateral",
    meta: menulateralucxtWBSF9uMeta || {},
    alias: menulateralucxtWBSF9uMeta?.alias || [],
    redirect: menulateralucxtWBSF9uMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/menulateral.vue").then(m => m.default || m)
  },
  {
    name: settingsiidKkQXhK1Meta?.name ?? "ooloja.old-settings",
    path: settingsiidKkQXhK1Meta?.path ?? "/ooloja.old/settings",
    meta: settingsiidKkQXhK1Meta || {},
    alias: settingsiidKkQXhK1Meta?.alias || [],
    redirect: settingsiidKkQXhK1Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/settings.vue").then(m => m.default || m)
  },
  {
    name: indexNv5if3amL9Meta?.name ?? "ooloja.old-vendas",
    path: indexNv5if3amL9Meta?.path ?? "/ooloja.old/vendas",
    meta: indexNv5if3amL9Meta || {},
    alias: indexNv5if3amL9Meta?.alias || [],
    redirect: indexNv5if3amL9Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja.old/vendas/index.vue").then(m => m.default || m)
  },
  {
    name: carrinhoswvTZqzLU7fMeta?.name ?? "ooloja-atacado-carrinhos",
    path: carrinhoswvTZqzLU7fMeta?.path ?? "/ooloja/atacado/carrinhos",
    meta: carrinhoswvTZqzLU7fMeta || {},
    alias: carrinhoswvTZqzLU7fMeta?.alias || [],
    redirect: carrinhoswvTZqzLU7fMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/atacado/carrinhos.vue").then(m => m.default || m)
  },
  {
    name: catalogoGw3uTxFvu5Meta?.name ?? "ooloja-atacado-catalogo",
    path: catalogoGw3uTxFvu5Meta?.path ?? "/ooloja/atacado/catalogo",
    meta: catalogoGw3uTxFvu5Meta || {},
    alias: catalogoGw3uTxFvu5Meta?.alias || [],
    redirect: catalogoGw3uTxFvu5Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/atacado/catalogo.vue").then(m => m.default || m)
  },
  {
    name: index9vScCBjkczMeta?.name ?? "ooloja-atacado-condicoes-parcelamento",
    path: index9vScCBjkczMeta?.path ?? "/ooloja/atacado/condicoes-parcelamento",
    meta: index9vScCBjkczMeta || {},
    alias: index9vScCBjkczMeta?.alias || [],
    redirect: index9vScCBjkczMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/atacado/condicoes-parcelamento/index.vue").then(m => m.default || m)
  },
  {
    name: index6ILS3NzQVjMeta?.name ?? "ooloja-atacado",
    path: index6ILS3NzQVjMeta?.path ?? "/ooloja/atacado",
    meta: index6ILS3NzQVjMeta || {},
    alias: index6ILS3NzQVjMeta?.alias || [],
    redirect: index6ILS3NzQVjMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/atacado/index.vue").then(m => m.default || m)
  },
  {
    name: pedidoskCFdlVxPFbMeta?.name ?? "ooloja-atacado-pedidos",
    path: pedidoskCFdlVxPFbMeta?.path ?? "/ooloja/atacado/pedidos",
    meta: pedidoskCFdlVxPFbMeta || {},
    alias: pedidoskCFdlVxPFbMeta?.alias || [],
    redirect: pedidoskCFdlVxPFbMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/atacado/pedidos.vue").then(m => m.default || m)
  },
  {
    name: cliente_45_91id_931nT43GXXv2Meta?.name ?? "ooloja-cadastros-clientes-cliente-id",
    path: cliente_45_91id_931nT43GXXv2Meta?.path ?? "/ooloja/cadastros/clientes/cliente-:id()",
    meta: cliente_45_91id_931nT43GXXv2Meta || {},
    alias: cliente_45_91id_931nT43GXXv2Meta?.alias || [],
    redirect: cliente_45_91id_931nT43GXXv2Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/cadastros/clientes/cliente-[id].vue").then(m => m.default || m)
  },
  {
    name: indexxiHmvcaiWGMeta?.name ?? "ooloja-cadastros-clientes",
    path: indexxiHmvcaiWGMeta?.path ?? "/ooloja/cadastros/clientes",
    meta: indexxiHmvcaiWGMeta || {},
    alias: indexxiHmvcaiWGMeta?.alias || [],
    redirect: indexxiHmvcaiWGMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/cadastros/clientes/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93h9kD88aQqVMeta?.name ?? "ooloja-cadastros-fabricantes-id",
    path: _91id_93h9kD88aQqVMeta?.path ?? "/ooloja/cadastros/fabricantes/:id()",
    meta: _91id_93h9kD88aQqVMeta || {},
    alias: _91id_93h9kD88aQqVMeta?.alias || [],
    redirect: _91id_93h9kD88aQqVMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/cadastros/fabricantes/[id].vue").then(m => m.default || m)
  },
  {
    name: indexS62OqCU5PjMeta?.name ?? "ooloja-cadastros-fabricantes",
    path: indexS62OqCU5PjMeta?.path ?? "/ooloja/cadastros/fabricantes",
    meta: indexS62OqCU5PjMeta || {},
    alias: indexS62OqCU5PjMeta?.alias || [],
    redirect: indexS62OqCU5PjMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/cadastros/fabricantes/index.vue").then(m => m.default || m)
  },
  {
    name: indexPGVRk5TcJzMeta?.name ?? "ooloja-cadastros",
    path: indexPGVRk5TcJzMeta?.path ?? "/ooloja/cadastros",
    meta: indexPGVRk5TcJzMeta || {},
    alias: indexPGVRk5TcJzMeta?.alias || [],
    redirect: indexPGVRk5TcJzMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/cadastros/index.vue").then(m => m.default || m)
  },
  {
    name: categoriasDx92HM3KJxMeta?.name ?? "ooloja-cadastros-produtos-categorias",
    path: categoriasDx92HM3KJxMeta?.path ?? "/ooloja/cadastros/produtos/categorias",
    meta: categoriasDx92HM3KJxMeta || {},
    alias: categoriasDx92HM3KJxMeta?.alias || [],
    redirect: categoriasDx92HM3KJxMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/cadastros/produtos/categorias.vue").then(m => m.default || m)
  },
  {
    name: indexb7OpLTMcg9Meta?.name ?? "ooloja-cadastros-vendas",
    path: indexb7OpLTMcg9Meta?.path ?? "/ooloja/cadastros/vendas",
    meta: indexb7OpLTMcg9Meta || {},
    alias: indexb7OpLTMcg9Meta?.alias || [],
    redirect: indexb7OpLTMcg9Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/cadastros/vendas/index.vue").then(m => m.default || m)
  },
  {
    name: aba_45avaliacoesHjE16DqZy6Meta?.name ?? "ooloja-catalogo-aba-avaliacoes",
    path: aba_45avaliacoesHjE16DqZy6Meta?.path ?? "/ooloja/catalogo/aba-avaliacoes",
    meta: aba_45avaliacoesHjE16DqZy6Meta || {},
    alias: aba_45avaliacoesHjE16DqZy6Meta?.alias || [],
    redirect: aba_45avaliacoesHjE16DqZy6Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-avaliacoes.vue").then(m => m.default || m)
  },
  {
    name: aba_45comentarios753D629Nd8Meta?.name ?? "ooloja-catalogo-aba-comentarios",
    path: aba_45comentarios753D629Nd8Meta?.path ?? "/ooloja/catalogo/aba-comentarios",
    meta: aba_45comentarios753D629Nd8Meta || {},
    alias: aba_45comentarios753D629Nd8Meta?.alias || [],
    redirect: aba_45comentarios753D629Nd8Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-comentarios.vue").then(m => m.default || m)
  },
  {
    name: aba_45dimencoe3SzkTaCXPeMeta?.name ?? "ooloja-catalogo-aba-dimencoe",
    path: aba_45dimencoe3SzkTaCXPeMeta?.path ?? "/ooloja/catalogo/aba-dimencoe",
    meta: aba_45dimencoe3SzkTaCXPeMeta || {},
    alias: aba_45dimencoe3SzkTaCXPeMeta?.alias || [],
    redirect: aba_45dimencoe3SzkTaCXPeMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-dimencoe.vue").then(m => m.default || m)
  },
  {
    name: aba_45geral2BHjUFstWFMeta?.name ?? "ooloja-catalogo-aba-geral",
    path: aba_45geral2BHjUFstWFMeta?.path ?? "/ooloja/catalogo/aba-geral",
    meta: aba_45geral2BHjUFstWFMeta || {},
    alias: aba_45geral2BHjUFstWFMeta?.alias || [],
    redirect: aba_45geral2BHjUFstWFMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-geral.vue").then(m => m.default || m)
  },
  {
    name: aba_45gerenciarestoque55kWSaLyLsMeta?.name ?? "ooloja-catalogo-aba-gerenciarestoque",
    path: aba_45gerenciarestoque55kWSaLyLsMeta?.path ?? "/ooloja/catalogo/aba-gerenciarestoque",
    meta: aba_45gerenciarestoque55kWSaLyLsMeta || {},
    alias: aba_45gerenciarestoque55kWSaLyLsMeta?.alias || [],
    redirect: aba_45gerenciarestoque55kWSaLyLsMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-gerenciarestoque.vue").then(m => m.default || m)
  },
  {
    name: aba_45precos28ad4koM4EMeta?.name ?? "ooloja-catalogo-aba-precos",
    path: aba_45precos28ad4koM4EMeta?.path ?? "/ooloja/catalogo/aba-precos",
    meta: aba_45precos28ad4koM4EMeta || {},
    alias: aba_45precos28ad4koM4EMeta?.alias || [],
    redirect: aba_45precos28ad4koM4EMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-precos.vue").then(m => m.default || m)
  },
  {
    name: aba_45variacoes2iZ1i1hHemMeta?.name ?? "ooloja-catalogo-aba-variacoes",
    path: aba_45variacoes2iZ1i1hHemMeta?.path ?? "/ooloja/catalogo/aba-variacoes",
    meta: aba_45variacoes2iZ1i1hHemMeta || {},
    alias: aba_45variacoes2iZ1i1hHemMeta?.alias || [],
    redirect: aba_45variacoes2iZ1i1hHemMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/aba-variacoes.vue").then(m => m.default || m)
  },
  {
    name: categoriasJWDeVdzEfIMeta?.name ?? "ooloja-catalogo-categorias",
    path: categoriasJWDeVdzEfIMeta?.path ?? "/ooloja/catalogo/categorias",
    meta: categoriasJWDeVdzEfIMeta || {},
    alias: categoriasJWDeVdzEfIMeta?.alias || [],
    redirect: categoriasJWDeVdzEfIMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/categorias.vue").then(m => m.default || m)
  },
  {
    name: func_45variacoesTYeMMe4uRoMeta?.name ?? "ooloja-catalogo-func-variacoes",
    path: func_45variacoesTYeMMe4uRoMeta?.path ?? "/ooloja/catalogo/func-variacoes",
    meta: func_45variacoesTYeMMe4uRoMeta || {},
    alias: func_45variacoesTYeMMe4uRoMeta?.alias || [],
    redirect: func_45variacoesTYeMMe4uRoMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/func-variacoes.js").then(m => m.default || m)
  },
  {
    name: imagens19RoxgahnoMeta?.name ?? "ooloja-catalogo-imagens",
    path: imagens19RoxgahnoMeta?.path ?? "/ooloja/catalogo/imagens",
    meta: imagens19RoxgahnoMeta || {},
    alias: imagens19RoxgahnoMeta?.alias || [],
    redirect: imagens19RoxgahnoMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/imagens.vue").then(m => m.default || m)
  },
  {
    name: produto_45_91id_93Zni9w0s1ruMeta?.name ?? "ooloja-catalogo-produto-id",
    path: produto_45_91id_93Zni9w0s1ruMeta?.path ?? "/ooloja/catalogo/produto-:id()",
    meta: produto_45_91id_93Zni9w0s1ruMeta || {},
    alias: produto_45_91id_93Zni9w0s1ruMeta?.alias || [],
    redirect: produto_45_91id_93Zni9w0s1ruMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/produto-[id].vue").then(m => m.default || m)
  },
  {
    name: produtosjjSmKivC3cMeta?.name ?? "ooloja-catalogo-produtos",
    path: produtosjjSmKivC3cMeta?.path ?? "/ooloja/catalogo/produtos",
    meta: produtosjjSmKivC3cMeta || {},
    alias: produtosjjSmKivC3cMeta?.alias || [],
    redirect: produtosjjSmKivC3cMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/produtos.vue").then(m => m.default || m)
  },
  {
    name: variacoesrwDU5uI3XTMeta?.name ?? "ooloja-catalogo-variacoes",
    path: variacoesrwDU5uI3XTMeta?.path ?? "/ooloja/catalogo/variacoes",
    meta: variacoesrwDU5uI3XTMeta || {},
    alias: variacoesrwDU5uI3XTMeta?.alias || [],
    redirect: variacoesrwDU5uI3XTMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/catalogo/variacoes.vue").then(m => m.default || m)
  },
  {
    name: abas6znw0RwjHbMeta?.name ?? "ooloja-configuracoes-abas",
    path: abas6znw0RwjHbMeta?.path ?? "/ooloja/configuracoes/abas",
    meta: abas6znw0RwjHbMeta || {},
    alias: abas6znw0RwjHbMeta?.alias || [],
    redirect: abas6znw0RwjHbMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/abas.vue").then(m => m.default || m)
  },
  {
    name: chatbotVdc0jWkMeNMeta?.name ?? "ooloja-configuracoes-chatbot",
    path: chatbotVdc0jWkMeNMeta?.path ?? "/ooloja/configuracoes/chatbot",
    meta: chatbotVdc0jWkMeNMeta || {},
    alias: chatbotVdc0jWkMeNMeta?.alias || [],
    redirect: chatbotVdc0jWkMeNMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/chatbot.vue").then(m => m.default || m)
  },
  {
    name: clientesFAa6HKjvBAMeta?.name ?? "ooloja-configuracoes-clientes",
    path: clientesFAa6HKjvBAMeta?.path ?? "/ooloja/configuracoes/clientes",
    meta: clientesFAa6HKjvBAMeta || {},
    alias: clientesFAa6HKjvBAMeta?.alias || [],
    redirect: clientesFAa6HKjvBAMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/clientes.vue").then(m => m.default || m)
  },
  {
    name: DEPRECATED_45empresaOovLPus9uOMeta?.name ?? "ooloja-configuracoes-DEPRECATED-empresa",
    path: DEPRECATED_45empresaOovLPus9uOMeta?.path ?? "/ooloja/configuracoes/DEPRECATED-empresa",
    meta: DEPRECATED_45empresaOovLPus9uOMeta || {},
    alias: DEPRECATED_45empresaOovLPus9uOMeta?.alias || [],
    redirect: DEPRECATED_45empresaOovLPus9uOMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/DEPRECATED-empresa.vue").then(m => m.default || m)
  },
  {
    name: erpyfDBiG3neyMeta?.name ?? "ooloja-configuracoes-erp",
    path: erpyfDBiG3neyMeta?.path ?? "/ooloja/configuracoes/erp",
    meta: erpyfDBiG3neyMeta || {},
    alias: erpyfDBiG3neyMeta?.alias || [],
    redirect: erpyfDBiG3neyMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/erp.vue").then(m => m.default || m)
  },
  {
    name: erpprodutosF6llPl5HT7Meta?.name ?? "ooloja-configuracoes-erpprodutos",
    path: erpprodutosF6llPl5HT7Meta?.path ?? "/ooloja/configuracoes/erpprodutos",
    meta: erpprodutosF6llPl5HT7Meta || {},
    alias: erpprodutosF6llPl5HT7Meta?.alias || [],
    redirect: erpprodutosF6llPl5HT7Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/erpprodutos.vue").then(m => m.default || m)
  },
  {
    name: indexZlcMWqjoMvMeta?.name ?? "ooloja-configuracoes",
    path: indexZlcMWqjoMvMeta?.path ?? "/ooloja/configuracoes",
    meta: indexZlcMWqjoMvMeta || {},
    alias: indexZlcMWqjoMvMeta?.alias || [],
    redirect: indexZlcMWqjoMvMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/index.vue").then(m => m.default || m)
  },
  {
    name: inputFormConfighCBh8uDET1Meta?.name ?? "ooloja-configuracoes-inputFormConfig",
    path: inputFormConfighCBh8uDET1Meta?.path ?? "/ooloja/configuracoes/inputFormConfig",
    meta: inputFormConfighCBh8uDET1Meta || {},
    alias: inputFormConfighCBh8uDET1Meta?.alias || [],
    redirect: inputFormConfighCBh8uDET1Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/inputFormConfig.vue").then(m => m.default || m)
  },
  {
    name: localizacaowkUKShIefXMeta?.name ?? "ooloja-configuracoes-localizacao",
    path: localizacaowkUKShIefXMeta?.path ?? "/ooloja/configuracoes/localizacao",
    meta: localizacaowkUKShIefXMeta || {},
    alias: localizacaowkUKShIefXMeta?.alias || [],
    redirect: localizacaowkUKShIefXMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/localizacao.vue").then(m => m.default || m)
  },
  {
    name: produtos5nRiM5VrTXMeta?.name ?? "ooloja-configuracoes-produtos",
    path: produtos5nRiM5VrTXMeta?.path ?? "/ooloja/configuracoes/produtos",
    meta: produtos5nRiM5VrTXMeta || {},
    alias: produtos5nRiM5VrTXMeta?.alias || [],
    redirect: produtos5nRiM5VrTXMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/produtos.vue").then(m => m.default || m)
  },
  {
    name: sendformssdtm1gTJtHMeta?.name ?? "ooloja-configuracoes-sendforms",
    path: sendformssdtm1gTJtHMeta?.path ?? "/ooloja/configuracoes/sendforms",
    meta: sendformssdtm1gTJtHMeta || {},
    alias: sendformssdtm1gTJtHMeta?.alias || [],
    redirect: sendformssdtm1gTJtHMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/configuracoes/sendforms.js").then(m => m.default || m)
  },
  {
    name: index4UXL9CjjsOMeta?.name ?? "ooloja",
    path: index4UXL9CjjsOMeta?.path ?? "/ooloja",
    meta: index4UXL9CjjsOMeta || {},
    alias: index4UXL9CjjsOMeta?.alias || [],
    redirect: index4UXL9CjjsOMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/index.vue").then(m => m.default || m)
  },
  {
    name: menulateralsIn19Wwl1rMeta?.name ?? "ooloja-menulateral",
    path: menulateralsIn19Wwl1rMeta?.path ?? "/ooloja/menulateral",
    meta: menulateralsIn19Wwl1rMeta || {},
    alias: menulateralsIn19Wwl1rMeta?.alias || [],
    redirect: menulateralsIn19Wwl1rMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/menulateral.vue").then(m => m.default || m)
  },
  {
    name: menuoolojaZozmWVOt3SMeta?.name ?? "ooloja-menuooloja",
    path: menuoolojaZozmWVOt3SMeta?.path ?? "/ooloja/menuooloja",
    meta: menuoolojaZozmWVOt3SMeta || {},
    alias: menuoolojaZozmWVOt3SMeta?.alias || [],
    redirect: menuoolojaZozmWVOt3SMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/menuooloja.vue").then(m => m.default || m)
  },
  {
    name: settings9GuBOyGvzmMeta?.name ?? "ooloja-settings",
    path: settings9GuBOyGvzmMeta?.path ?? "/ooloja/settings",
    meta: settings9GuBOyGvzmMeta || {},
    alias: settings9GuBOyGvzmMeta?.alias || [],
    redirect: settings9GuBOyGvzmMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/ooloja/settings.vue").then(m => m.default || m)
  },
  {
    name: indexo8VqjevYfCMeta?.name ?? "perfil",
    path: indexo8VqjevYfCMeta?.path ?? "/perfil",
    meta: indexo8VqjevYfCMeta || {},
    alias: indexo8VqjevYfCMeta?.alias || [],
    redirect: indexo8VqjevYfCMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/perfil/index.vue").then(m => m.default || m)
  },
  {
    name: gerapdfFEVSlrO9D8Meta?.name ?? "testes-gerapdf",
    path: gerapdfFEVSlrO9D8Meta?.path ?? "/testes/gerapdf",
    meta: gerapdfFEVSlrO9D8Meta || {},
    alias: gerapdfFEVSlrO9D8Meta?.alias || [],
    redirect: gerapdfFEVSlrO9D8Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/testes/gerapdf.vue").then(m => m.default || m)
  },
  {
    name: grapsvJvPyRaoBQMeta?.name ?? "testes-graps",
    path: grapsvJvPyRaoBQMeta?.path ?? "/testes/graps",
    meta: grapsvJvPyRaoBQMeta || {},
    alias: grapsvJvPyRaoBQMeta?.alias || [],
    redirect: grapsvJvPyRaoBQMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/testes/graps.vue").then(m => m.default || m)
  },
  {
    name: indexK0SLZVzWnsMeta?.name ?? "testes",
    path: indexK0SLZVzWnsMeta?.path ?? "/testes",
    meta: indexK0SLZVzWnsMeta || {},
    alias: indexK0SLZVzWnsMeta?.alias || [],
    redirect: indexK0SLZVzWnsMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/testes/index.vue").then(m => m.default || m)
  },
  {
    name: mapasClEGhRnU8zMeta?.name ?? "testes-mapas",
    path: mapasClEGhRnU8zMeta?.path ?? "/testes/mapas",
    meta: mapasClEGhRnU8zMeta || {},
    alias: mapasClEGhRnU8zMeta?.alias || [],
    redirect: mapasClEGhRnU8zMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/testes/mapas.vue").then(m => m.default || m)
  },
  {
    name: megasena6FxFVo4Va7Meta?.name ?? "testes-megasena",
    path: megasena6FxFVo4Va7Meta?.path ?? "/testes/megasena",
    meta: megasena6FxFVo4Va7Meta || {},
    alias: megasena6FxFVo4Va7Meta?.alias || [],
    redirect: megasena6FxFVo4Va7Meta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/testes/megasena.vue").then(m => m.default || m)
  },
  {
    name: myPlugin1pRPYk3erWMeta?.name ?? "testes-plugins-myPlugin",
    path: myPlugin1pRPYk3erWMeta?.path ?? "/testes/plugins/myPlugin",
    meta: myPlugin1pRPYk3erWMeta || {},
    alias: myPlugin1pRPYk3erWMeta?.alias || [],
    redirect: myPlugin1pRPYk3erWMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/testes/plugins/myPlugin.js").then(m => m.default || m)
  },
  {
    name: selecttbAuMsTd3pMeta?.name ?? "testes-select",
    path: selecttbAuMsTd3pMeta?.path ?? "/testes/select",
    meta: selecttbAuMsTd3pMeta || {},
    alias: selecttbAuMsTd3pMeta?.alias || [],
    redirect: selecttbAuMsTd3pMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/testes/select.vue").then(m => m.default || m)
  },
  {
    name: tvLKhS8LyclMeta?.name ?? "testes-t",
    path: tvLKhS8LyclMeta?.path ?? "/testes/t",
    meta: tvLKhS8LyclMeta || {},
    alias: tvLKhS8LyclMeta?.alias || [],
    redirect: tvLKhS8LyclMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/testes/t.vue").then(m => m.default || m)
  },
  {
    name: _91id_937eupM3tgHnMeta?.name ?? "usuarios-id",
    path: _91id_937eupM3tgHnMeta?.path ?? "/usuarios/:id()",
    meta: _91id_937eupM3tgHnMeta || {},
    alias: _91id_937eupM3tgHnMeta?.alias || [],
    redirect: _91id_937eupM3tgHnMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/usuarios/[id].vue").then(m => m.default || m)
  },
  {
    name: indexAs8VwvyG2LMeta?.name ?? "usuarios",
    path: indexAs8VwvyG2LMeta?.path ?? "/usuarios",
    meta: indexAs8VwvyG2LMeta || {},
    alias: indexAs8VwvyG2LMeta?.alias || [],
    redirect: indexAs8VwvyG2LMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/usuarios/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93tG7sK5a08TMeta?.name ?? "videos-id",
    path: _91id_93tG7sK5a08TMeta?.path ?? "/videos/:id()",
    meta: _91id_93tG7sK5a08TMeta || {},
    alias: _91id_93tG7sK5a08TMeta?.alias || [],
    redirect: _91id_93tG7sK5a08TMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/videos/[id].vue").then(m => m.default || m)
  },
  {
    name: frmBuscas4J39Sj0ozMeta?.name ?? "videos-frmBusca",
    path: frmBuscas4J39Sj0ozMeta?.path ?? "/videos/frmBusca",
    meta: frmBuscas4J39Sj0ozMeta || {},
    alias: frmBuscas4J39Sj0ozMeta?.alias || [],
    redirect: frmBuscas4J39Sj0ozMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/videos/frmBusca.vue").then(m => m.default || m)
  },
  {
    name: indexlUnunui40hMeta?.name ?? "videos",
    path: indexlUnunui40hMeta?.path ?? "/videos",
    meta: indexlUnunui40hMeta || {},
    alias: indexlUnunui40hMeta?.alias || [],
    redirect: indexlUnunui40hMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/videos/index.vue").then(m => m.default || m)
  },
  {
    name: settingsv43Od2Pz0dMeta?.name ?? "videos-settings",
    path: settingsv43Od2Pz0dMeta?.path ?? "/videos/settings",
    meta: settingsv43Od2Pz0dMeta || {},
    alias: settingsv43Od2Pz0dMeta?.alias || [],
    redirect: settingsv43Od2Pz0dMeta?.redirect || undefined,
    component: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/pages/videos/settings.vue").then(m => m.default || m)
  }
]